<template>
    <footer style="margin-top: 30px">
        <!-- 支持机构 -->
        <div class="support-organ">
            <div class="main">
                <div class="support-organ-main">
                    <div class="title">
                        <!-- <img src="../../static/images/link_line.png" alt="" /> -->
                        友情链接
                    </div>
                    <ul class="list">
                        <li
                            v-for="(item, index) in linkList"
                            :key="index"
                            class="item"
                        >
                            <a :href="item.url" target="_black">{{
                                item.title
                            }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="footer-main">
            <div class="main">
                <!-- <div class="title">
                    <img
                        src="../../static/images/logo_02.png"
                        alt=""
                        width="193px"
                        height="33px"
                    />
                </div> -->

                <div class="clearfix">
                    <div class="fl" style="width: 885px">
                        <div style="margin-top: 16px">
                            地址：北京市海淀区三里河路13号
                        </div>
                        <div>电话：010-88082110； 88082105； 88082156；</div>
                        <div>传真：010-88082105</div>
                        <div>
                            邮箱：
                            <a
                                href="mailto:tccacc@163.com"
                                target="_black"
                                style="color: #608be4"
                                >tccacc@163.com</a
                            >
                        </div>
                        <div>
                            自 2010-2017 中国建筑文化中心培训中心版权所有 ALL Rights Reserved.
                        </div>

                        <div>
                            <a
                                href="http://beian.miit.gov.cn/"
                                target="_black"
                                style="color: #939393;margin-right: 14px;"
                                >京ICP备11023824号-1</a
                            >
                            <span>京公网安备11010802039952号-1</span>
                        </div>
                    </div>
                    <div class="fl" style="margin-top: 50px">
                        <img src="../../static/image/blue.png" alt="" />
                        <!-- <p>微信公众号</p> -->
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { getDict, getDictPageList } from "../api/dict";
import { getNewsList } from "../api/news.js";
export default {
    data() {
        return {
            //友情链接
            linkList: [],

            navList: [
                {
                    name: "首页",
                    path: "/index/HomePage",
                },
                {
                    name: "协会概况",
                    path: "/index/AboutUsList",
                },
                {
                    name: "行业动态",
                    path: "/index/LinkList",
                },
                {
                    name: "标准规范",
                    path: "/index/StandardList",
                },
                {
                    name: "政策法规",
                    path: "/index/PolicyList",
                },
                {
                    name: "行业研究",
                    path: "/index/ResearchList",
                },
                {
                    name: "学习中心",
                    path: "/index/CourseHome",
                },
                {
                    name: "舞台舞美",
                    path: "index/WM_HomePage",
                },
                {
                    name: "网络表演",
                    path: "index/NP_HomePage",
                },
            ],
        };
    },
    created() {
        this.getNewsLinkList();
    },
    methods: {
        handleLinkType(item) {
            this.linkParams.dictId = item.id;
            this.linkParams.dictName = item.name;
            this.getNewsLinkList();
        },

        getNewsLinkList() {
            let params = {
                page: 1,
                pageSize: 10,
                parentId: 5,
            };
            getNewsList(params).then((res) => {
                if (res.code == 200) {
                    this.linkList = res.data.records;
                }
            });
        },

        handlePath(item) {
            this.$router.push({
                path: item.path,
            });
        },
    },
};
</script>

<style scoped>
footer {
    width: 100%;
    color: #d3d3d7;
    line-height: 30px;
}

footer .main {
    font-size: 14px;
}

footer a {
    color: #d3d3d7;
}

footer a:hover {
    color: #000;
}

.support-organ {
    width: 100%;
    height: auto;
    background: #f9f9f9;
    border-top: 2px solid #e9e9e9;
}

.support-organ-main {
    padding: 30px 0;
}

.support-organ-main .list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-left: -8px;
    margin-right: -8px;
}

.support-organ-main .item {
    line-height: 30px;
    font-size: 14px;
}

.support-organ-main .item a {
    padding: 0 8px;
    border-right: 1px solid #666666;
    color: #666666;
}

.support-organ-main .item:last-child a {
    border-right: 0;
}

.support-organ-main .item a:hover {
    color: #2763ce;
}

.footer-main {
    padding: 10px 0 30px 0;
    background: #404143;
}

.support-organ .title {
    color: #004b85;
    font-weight: bold;
    font-size: 18px;
}

.footer-main .ft_nav {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
}

.footer-main .ft_nav li {
    margin-right: 15px;
}

footer p {
    color: #d3d3d7;
    font-size: 14px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/MainFooter.vue